import { AuthenticatedLayout } from "../../../layouts/AuthenticatedLayout/AuthenticatedLayout";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { FC } from "react";
import { TaxSlipCategoryList } from "../../../components/TaxSlipCategory";

export interface ITaxSlipCategoryListPage {}

export const TaxSlipCategoryListPage: FC<ITaxSlipCategoryListPage> = () => {
  return (
    <AuthenticatedLayout
      pageTitle="TaxSlip Category"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[{text: 'TaxSlip Category', navigateTo: '/taxslip-categories/list'}]}
      mainContents={<TaxSlipCategoryList />}
    />
  );
};
